import { createFileRoute } from '@tanstack/react-router'
import { FinalCheck } from '@/components/installFlowV2/final-check'
import { z } from 'zod'

export const Route = createFileRoute('/installFlow/final-check')({
  component: FinalCheck,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
})

